<template>
  <div id="chinaChart"></div>
</template>

<script>
import * as echarts from 'echarts'
import chinaJson from '@/assets/china/china.json'
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      geoMap: [
        { ename: '65', value: 0, name: '新疆', cp: [84.9023, 41.748] },
        { ename: '54', value: 0, name: '西藏', cp: [88.7695, 31.6846] },
        { ename: '15', value: 0, name: '内蒙古', cp: [117.5977, 44.3408] },
        { ename: '63', value: 0, name: '青海', cp: [96.2402, 35.4199] },
        { ename: '51', value: 0, name: '四川', cp: [102.9199, 30.1904] },
        { ename: '23', value: 0, name: '黑龙江', cp: [128.1445, 48.5156] },
        { ename: '62', value: 0, name: '甘肃', cp: [95.7129, 40.166] },
        { ename: '53', value: 0, name: '云南', cp: [101.8652, 25.1807] },
        { ename: '45', value: 0, name: '广西', cp: [108.2813, 23.6426] },
        { ename: '43', value: 0, name: '湖南', cp: [111.5332, 27.3779] },
        { ename: '61', value: 0, name: '陕西', cp: [109.5996, 35.6396] },
        { ename: '44', value: 0, name: '广东', cp: [113.4668, 22.8076] },
        { ename: '22', value: 0, name: '吉林', cp: [126.4746, 43.5938] },
        { ename: '13', value: 0, name: '河北', cp: [115.4004, 37.9688] },
        { ename: '42', value: 0, name: '湖北', cp: [112.2363, 31.1572] },
        { ename: '52', value: 0, name: '贵州', cp: [106.6113, 26.9385] },
        { ename: '37', value: 0, name: '山东', cp: [118.7402, 36.4307] },
        { ename: '36', value: 0, name: '江西', cp: [116.0156, 27.29] },
        { ename: '41', value: 0, name: '河南', cp: [113.4668, 33.8818] },
        { ename: '21', value: 0, name: '辽宁', cp: [122.3438, 41.0889] },
        { ename: '14', value: 0, name: '山西', cp: [112.4121, 37.6611] },
        { ename: '34', value: 0, name: '安徽', cp: [117.2461, 32.0361] },
        { ename: '35', value: 0, name: '福建', cp: [118.3008, 25.9277] },
        { ename: '33', value: 0, name: '浙江', cp: [120.498, 29.0918] },
        { ename: '32', value: 0, name: '江苏', cp: [120.0586, 32.915] },
        { ename: '50', value: 0, name: '重庆', cp: [107.7539, 30.1904] },
        { ename: '64', value: 0, name: '宁夏', cp: [105.9961, 37.3096] },
        { ename: '46', value: 0, name: '海南', cp: [109.9512, 19.2041] },
        { value: 0, name: '台湾', cp: [121.0254, 23.5986] },
        { ename: '11', value: 0, name: '北京', cp: [116.4551, 40.2539] },
        { ename: '12', value: 0, name: '天津', cp: [117.4219, 39.4189] },
        { ename: '31', value: 0, name: '上海', cp: [121.4648, 31.2891] },
        { ename: '81', value: 0, name: '香港', cp: [114.2578, 22.3242] },
        { ename: '82', value: 0, name: '澳门', cp: [113.5547, 22.1484] },
      ],
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.initChart()
        })
      },
    },
  },
  methods: {
    initChart() {
      echarts.registerMap('china', chinaJson)
      const myChart = echarts.init(document.getElementById('chinaChart'))
      window.addEventListener('resize', () => myChart.resize())
      // 需要高亮的省
      var dataList = this.data.map(item => {
        return {
          name: item.provinceName,
          ename: this.geoMap.find(ele => ele.name === item.provinceName).ename,
          value: item.projectCount,
          houseCount: item.houseCount,
          publicBuildingCount: item.publicBuildingCount,
        }
      })
      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          formatter(params) {
            // params.data 就是series配置项中的data数据遍历
            const localValue = params.data ? params.data.value : 0
            const houseCount = params.data ? params.data.houseCount : 0
            const publicBuildingCount = params.data ? params.data.publicBuildingCount : 0
            const htmlStr = `
          <div style='padding:8px 100px 0 8px'>
            <div style='font-size:18px;color:#ffffff'> ${params.name}</div>
          <p style='text-align:left;margin-top:6px;color:#ffffff'>
            项目总数：${localValue || 0}${Number(localValue || 0) >= 10000 ? '万个' : '个'}
          </p>
          <p style='text-align:left;margin-top:6px;color:#ffffff'>
            住宅数量：${houseCount || 0}${Number(houseCount || 0) >= 10000 ? '万个' : '个'}
          </p>
          <p style='text-align:left;margin-top:6px;color:#ffffff'>
            公建数量：${publicBuildingCount || 0}${Number(publicBuildingCount || 0) >= 10000 ? '万个' : '个'}
          </p></div>
        `
            return htmlStr
          },
          backgroundColor: 'rgba(5, 24, 100, 0.72)',
          borderColor: 'rgba(136, 220, 253, 0.17)',
        },
        geo: [
          {
            map: 'china',
            aspectScale: 0.85,
            layoutCenter: ['45%', '50%'], //地图位置
            layoutSize: '135%',
            zindex: 1,
            itemStyle: {
              normal: {
                areaColor: '#104597',
                borderColor: '#346ED1',
                borderWidth: 2,
              },
            },
            // 高亮状态下的多边形和标签样式。
            emphasis: {
              itemStyle: {
                areaColor: '#195ECA',
              },
              label: {
                color: '#5B8ACE',
                fontWeight: 'bold',
              },
            },
            select: {
              itemStyle: {
                areaColor: '#195ECA',
              },
              label: {
                color: '#5B8ACE',
                fontWeight: 'bold',
              },
            },
            label: {
              normal: {
                show: true,
                color: '#A1C1F1',
              },
            },

            regions: [
              // {
              //   name: '南海诸岛',
              //   itemStyle: {
              //     areaColor: '#002F54',
              //     borderColor: '#1EA3FF',
              //     normal: {
              //       opacity: 0,
              //       label: {
              //         show: false,
              //         color: '#009cc9',
              //       },
              //     },
              //   },
              //   label: {
              //     show: false,
              //     color: '#FFFFFF',
              //     fontSize: 12,
              //   },
              // },
            ],
          },
          {
            type: 'map',
            map: 'china',
            aspectScale: 0.85,
            layoutCenter: ['45%', '51%'], //地图位置
            layoutSize: '135%',
            roam: false,
            silent: true,
            label: {
              show: false,
            },
            itemStyle: {
              normal: {
                areaColor: '#104597',
                borderColor: '#104698',
                borderWidth: 8,
              },
              emphasis: { show: false },
            },
            select: { show: false },
            tooltip: {
              show: false,
            },
            regions: [
              {
                name: '南海诸岛',
                itemStyle: {
                  // 隐藏地图
                  normal: {
                    opacity: 0, // 为 0 时不绘制该图形
                  },
                },
                label: {
                  show: false, // 隐藏文字
                },
              },
            ],
            zlevel: -1,
          },
        ],
        series: [
          {
            type: 'map',
            map: 'china',
            aspectScale: 0.85,
            layoutCenter: ['45%', '50%'], //地图位置
            layoutSize: '135%',
            geoIndex: 0,
            roam: false,
            zlevel: 1,
            data: dataList,
          },
          // {
          //   type: 'scatter',
          //   coordinateSystem: 'geo',
          //   data: this.scatterData(dataList),
          //   geoIndex: 0,
          //   silent: true, // 不影响鼠标事件
          //   symbolSize: [16, 18],
          //   symbolOffset: [0, -15],
          //   z: 999,
          //   tooltip: {
          //     show: false,
          //   },
          //   zlevel: 2,
          //   itemStyle: {
          //     color: '#00E5FF',
          //     opacity: 1,
          //   },
          //   symbol:
          //     'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAIdSURBVCiRdZDNS1RhFIef8773zrfj6KiNU9QIEbQIwq1BSIv+gFZuApetW7du31Yqog9s4SIoRA1aBLZzUREhWeRIaDSZH81l7r3ve1qYYtr8Vofzex4OHOFILm5GjSpm8ofoDS9EdW/vNJPO4w9DpfXDnOwP4xuda7+sm9hK3aUNn6aoKgIoZjjImDIsFFVmXteKzwDk6mZy67Nz17+7NBclaSRpGuNcivcOAGusGhsS2EwhCPKDNmifs8GDwBk71i8mH6j6NdJ228uuqMSoSVEV0ECFTAlbqtsgVwozhVhkTK5sJuNLob3tod1QekudNNeM41bT+Z+ISiMIqyfDsG87Y6MvwlYIpVErNwXgwrZ7+M5KAdWOAc6q1E556oD7avi2IroBCCK50VS3l3rtpAGoi7lX2XtU5IXdZaOrTSPry5bVFdE1hN8I0YDHDqR+CsAAzPXIq5FEWwgpEOOJBU1EiRE6QAK4Btqcr4aLByLAEP5pRcmzt/WCeMABHmBITamm5sk+fyDOVcKXI54YCAGrqPztAyBz2vnW87K8OSYC1FIzU1Z6UbIggQohSrbqpf+EmOnD7D/ibL/MNhwgUvCqWYUsIsUzSOtFWRa7igA1MdNFpeKFrIrk+zzVQeXRUU6OLgDO7/iFCIY7QjKo8vFtj0wcZY5dBKh5fz8rFEpKeQCm/sd0zfiOvr+8o/Pd+qBbYT13cwGfuvV/AKXd31tQBdbpAAAAAElFTkSuQmCC',
          // },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: this.scatterData(dataList),
            geoIndex: 0,
            symbolSize: 8,
            silent: true, // 不影响鼠标事件
            tooltip: {
              show: false,
            },
            zlevel: 2,
            encode: {
              value: 2,
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke',
              color: '#F9442F',
              period: 9,
              scale: 3,
            },
            hoverAnimation: true,
            itemStyle: {
              color: '#F9442F',
              shadowBlur: 2,
              shadowColor: '#333',
            },
          },
        ],
      }
      myChart.on('click', params => {
        const item = this.geoMap.find(ele => ele.name === params.name)
        if (!item || !item.ename) return this.$message.error('暂无' + item.name + '地图数据')
        this.$emit('changeProvince', {
          provinceName: item.ename,
          province: item.name,
        })
      })
      option && myChart.setOption(option)
    },

    scatterData(data) {
      return data.map(item => {
        const targetItem = this.geoMap.find(ele => ele.name === item.name)
        return {
          value: targetItem.cp,
          name: item.name,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#chinaChart {
  width: 100%;
  height: 100%;
}
</style>
